import actions from './actions'
import getters from './getters'
import Custom from './custom'
import { mutations } from './mutations'

const state = {
  commonObj: {
    hasDropdownLoaded: false,
    componentList: [],
    divisionList: [],
    divisionListAll: [],
    districtList: [],
    districtListAll: [],
    upazilaList: [],
    upazilaListAll: [],
    thanaList: [],
    moduleList: [],
    serviceList: [],
    unionList: [],
    unionListAll: [],
    cityCorporationList: [],
    cityCorporationListAll: [],
    municipalityList: [],
    municipalityListAll: [],
    orgProfileList: [],
    fiscalYearList: [],
    wardList: [],
    dialogueInfosList: [],
    designationList: [],
    bankList: [],
    branchList: [],
    officeTypeList: [],
    officeList: [],
    menuList: [],
    notificationTemplateList: [],
    templateList: [],
    notificationTypeList: [],
    documentCategoryList: [],
    ministryNameList: [],
    portalServiceTypeList: Custom.portalServiceTypeList,
    orgComponentList: [],
    portalServiceCategoryList: [],
    portalCustomerTypeList: [],
    exOrgList: [],
    externalPanelList: [],
    externalMenuList: [],
    componentOrgList: [],
    componentDesignationList: [],
    countryList: [],
    portalServiceNameList: [],
    subDesignationList: []
  }
}

export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations
}
